import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export default function RateMovement({ rate, compact = false }) {
  const known = rate?.comparison_available === true && Number.isFinite(rate?.change_percent) && ['up', 'down', 'unchanged'].includes(rate?.direction);
  if (!known) return <span className="text-xs text-muted-foreground" aria-label="Previous source session comparison unavailable">Comparison unavailable</span>;
  const direction = rate.direction;
  const Icon = direction === 'up' ? TrendingUp : direction === 'down' ? TrendingDown : Minus;
  const value = Math.abs(rate.change_percent);
  const amount = direction === 'unchanged' ? '0.00%' : value < 0.005 ? '<0.01%' : value.toFixed(2) + '%';
  const text = direction === 'unchanged' ? 'Unchanged 0.00%' : (direction === 'up' ? 'Up +' : 'Down −') + amount;
  const date = rate.previous_source_date;
  const session = rate.previous_session;
  const comparison = date && session ? ' vs ' + date + ' ' + session + ' IBJA session' : ' vs previous IBJA session';
  return <span className={'inline-flex items-center gap-1 text-xs font-mono ' + (direction === 'up' ? 'text-green-500' : direction === 'down' ? 'text-red-500' : 'text-muted-foreground')} aria-label={text + comparison} title={text + comparison} data-testid="rate-movement">
    <Icon className="w-3 h-3" aria-hidden="true" />
    <span>{text}{!compact && <span className="block text-[10px] text-muted-foreground">{comparison.trim()}</span>}</span>
  </span>;
}
